import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { CpAuthenticationService } from '../cp-authentication.service';
import { SharedDataService } from '../../services/shared-data.service';
import { COMMON_MESSAGES } from '../../messages';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  // Dont Show API errors for the below HTTP calls.
  noErrorUrls = [
    '/users/get_temp_otp_token/',
    '/users/loginnew/'
  ];

  constructor(
    private authenticationService: CpAuthenticationService,
    private toastr: ToastrService,
    private sharedData: SharedDataService
  ) { }

  // Returns if a value is an object
  isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
  }

  /**
   * Check if the request URL is among the no Error URLS array above.
   * @param requestUrl the http request address.
   */
  isNoErrorUrl(requestUrl) {
    const retVal = this.noErrorUrls.reduce((accumulator, currentVal) => {
      return (accumulator || requestUrl.includes(currentVal));
    }, false);
    return retVal;
  }

  getErrorString(objectErr) {
    const retArr = [];
    Object.keys(objectErr).forEach((key) => {
      if (this.isObject(objectErr[key])) {
        retArr.push(this.getErrorString(objectErr[key]));
      } else {
        retArr.push(key + ': ' + objectErr[key]);
      }
    });
    return retArr.join('<br />');
  }

  parseAndAddErrorsFromArray(errorArr, errorList, title) {
    const errorTitle = title ? title + ': ' : '';
    errorArr.forEach((singleError) => {
      if (typeof singleError === 'string' || singleError instanceof String) {
        errorList.push(errorTitle + singleError);
      } else {
        Object.keys(singleError).forEach((keyN) => {
          errorList.push(`${errorTitle} ${keyN} : ` + singleError[keyN].join(''));
        });
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let errorList = [];
    return next.handle(request).pipe(catchError(err => {
      // check if we want to show the error messages.
      // This is done to fix the security issue that the end user
      // should not be hinted for missing user name.
      // #SECURITY #USERNAME_ENUMERATION
      if (this.isNoErrorUrl(err.url)) {
        return throwError(err);
      }

      if (err.status === 401) {
        this.toastr.warning(COMMON_MESSAGES.SESSION_EXPIRY);
        // auto logout if 401 response returned from api
        this.authenticationService.logout(false);
      }
      if (err.status === 0) {
        this.toastr.error(COMMON_MESSAGES.NO_INTERNET);
      } else if (err.status === 403) {
        this.toastr.warning(COMMON_MESSAGES.SESSION_EXPIRY);
        this.authenticationService.logout(false);
      } else if (err.status === 404) {
        this.toastr.error(COMMON_MESSAGES.RESOURCE_NOT_FOUND);
      } else if (err.status === 413) {
        // !ToDo fix max file size on the frontend and get proper error status from BE.
        this.toastr.error(COMMON_MESSAGES.FILE_SIZE_EXCEEDED);
      } else if (err.status === 400) {
        errorList = [];
        if (err.error.constructor === Array) {
          this.parseAndAddErrorsFromArray(err.error, errorList, '');
        } else {
          Object.keys(err.error).forEach((key) => {
            if (this.isObject(err.error[key])) {
              errorList.push(this.getErrorString(err.error[key]));
            } else if (err.error[key].constructor === Array) {
              this.parseAndAddErrorsFromArray(err.error[key], errorList, key);
            } else {
              errorList.push(key + ': ' + err.error[key]);
            }
          });
        }
        this.toastr.error(errorList.join('<br />'));
      } else if (err.status === 500) {
        this.toastr.error(COMMON_MESSAGES.INTERNET_SERVER_ERROR);
      } else {
        errorList = [];
        Object.keys(err.error).forEach((key) => {
          errorList.push(key + ': ' + err.error[key]);
        });
        this.toastr.error(errorList.join('<br />'));
      }

      return throwError(err);
    }));
  }
}
